import { createSlice } from "@reduxjs/toolkit";

const newRowsSlice = createSlice({
      name: 'newRows',
      initialState: {
            data: ['6422aeed667c0d4db1214f3b'], // sample item added just for testing
      },
      reducers: {
            setNew: (state, action) => {
                  state.data.push(action.payload);
            },
            removeNew: (state, action) => {
                  const index = state.data.indexOf(action.payload);
                  if (index > -1) { // only splice array when item is found
                        state.data.splice(index, 1); // 2nd parameter means remove one item only
                  }
            },
      }
});

export const {
      setNew,
      removeNew
} = newRowsSlice.actions;

export default newRowsSlice.reducer;